import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, map, of, switchMap } from 'rxjs';
import { createSignedBlockExtended } from "../type/index.js";
import { memo } from "../util/index.js";
/**
 * @name subscribeNewBlocks
 * @returns The latest block & events for that block
 */

export function subscribeNewBlocks(instanceId, api) {
  return memo(instanceId, function () {
    return api.derive.chain.subscribeNewHeads().pipe(switchMap(function (header) {
      var blockHash = header.createdAtHash || header.hash; // we get the block first, setting up the registry

      return combineLatest([of(header), api.rpc.chain.getBlock(blockHash), api.queryAt(blockHash).pipe(switchMap(function (queryAt) {
        return queryAt.system.events();
      }))]);
    }), map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          header = _ref2[0],
          block = _ref2[1],
          events = _ref2[2];

      return createSignedBlockExtended(block.registry, block, events, header.validators);
    }));
  });
}